(function() {
    'use strict';

    a3_pilot_reports.controller('TraineeSignatureModalCtrl', TraineeSignatureModalCtrl)
    /**
     * @memberof PilotReports
     * @ngdoc controller
     * @name TraineeSignatureModalCtrl
     * @description 
     * Shows Show Signature 
     * @ngInject
     */

    function TraineeSignatureModalCtrl($scope, $timeout, $uibModalInstance, trainee, TrainingSessionFactory, signatureSuccess){
        $scope.close = close;
        $scope.confirmReset = confirmReset;
        $scope.traineeSign = traineeSign;
        $scope.continue = continueWarning;
        $scope.confirmation = false;

        initialiazeTrainee(trainee);
        function initialiazeTrainee(trainee){
            var signatureTrainee = deepCopy(trainee);

            signatureTrainee.Session.Authorized = trainee.Session.Authorized ? trainee.Session.Authorized : false;
            signatureTrainee.errorMessage = "";
            signatureTrainee.successMessage = "";
            signatureTrainee.responseText = null;
            signatureTrainee.responseHasErrors = null;
            signatureTrainee.success = false;
            signatureTrainee.isLoading = false;
            signatureTrainee.password = "";
            signatureTrainee.username = trainee.AimsId;
            signatureTrainee.PositionCode = trainee.position ? trainee.position : trainee.PositionCode;

            $scope.signatureTrainee = signatureTrainee;
        }

        function deepCopy(originalObject) {
            return JSON.parse(JSON.stringify(originalObject));
        }

        function traineeSign(signatureTrainee){

            if(!signatureTrainee.password || !signatureTrainee.username){
                signatureTrainee.errorMessage = "Signature is required. Please enter your username and password.";
            }
            else{
                signatureTrainee.isLoading = true;
                //Individually authorize trainee
                var credentials =
                {
                    CrewId : signatureTrainee.CrewId,
                    Password : signatureTrainee.password,
                    Username : signatureTrainee.username,
                    PositionCode : signatureTrainee.PositionCode
                };

                if($scope.isOffline){
                    $timeout(function () {
                        signatureTrainee.isLoading = false;
                    }, 100);
                    signatureTrainee.errorMessage = "Online mode is required in order to sign. Please connect to the internet and try again.";
                }
                else{
                    TrainingSessionFactory.authorizeTrainee(credentials, function (responseData) {
                        signatureTrainee.isLoading = false;
                        signatureTrainee.success = true;
                        signatureTrainee.Session.Authorized = true;

                        signatureTrainee.Session.Authorized = true;
                        trainee.Session.Authorized = true;

                        signatureSuccess();

                        
                    }).catch(function(data){
                        signatureTrainee.isLoading = false;
                        if(data.data && data.data.errorMessage){
                            signatureTrainee.errorMessage = data.data.errorMessage;
                        }
                        else{
                            signatureTrainee.errorMessage = "An error occured during your authentication";
                        }
                    });
                }
            }
            // clear credentials
            trainee.username = "";
            trainee.password = "";
        }

        /**
         * Close the modal
         */
        function close(){
            $uibModalInstance.close(false);
        }

        /**
         * Confirm
         */
         function confirmReset(){
            $uibModalInstance.close(true);
        }

        function continueWarning(){
            $scope.confirmation = true;
        }
    }
})();